var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1812_11319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 6.66672V10.8334C13.3327 11.4964 13.5961 12.1323 14.0649 12.6012C14.5338 13.07 15.1696 13.3334 15.8327 13.3334C16.4957 13.3334 17.1316 13.07 17.6005 12.6012C18.0693 12.1323 18.3327 11.4964 18.3327 10.8334V10.0001C18.3326 8.11924 17.6962 6.29378 16.5271 4.8205C15.358 3.34721 13.7248 2.31274 11.8932 1.8853C10.0616 1.45786 8.1393 1.66259 6.43881 2.46619C4.73832 3.2698 3.35969 4.62502 2.52707 6.31149C1.69446 7.99796 1.45683 9.9165 1.85283 11.7551C2.24883 13.5938 3.25517 15.2444 4.70821 16.4386C6.16126 17.6328 7.97555 18.3003 9.85608 18.3327C11.7366 18.365 13.5728 17.7603 15.066 16.6167M13.3327 10.0001C13.3327 11.841 11.8403 13.3334 9.99936 13.3334C8.15841 13.3334 6.66603 11.841 6.66603 10.0001C6.66603 8.1591 8.15841 6.66672 9.99936 6.66672C11.8403 6.66672 13.3327 8.1591 13.3327 10.0001Z",
    stroke: "#DEB52F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1812_11319"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.c660776e11ad15a97abfbf7f1c7aa8b4.svg";
export { ForwardRef as ReactComponent };